import { render, staticRenderFns } from "./InspectionFormViewReminders.vue?vue&type=template&id=fd3e42e6"
import script from "./InspectionFormViewReminders.vue?vue&type=script&lang=js"
export * from "./InspectionFormViewReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports